(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-sso-url-log', {
                parent: 'entity',
                url: '/rcopia-sso-url-log',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaSsoUrlLogs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-sso-url-log/list/rcopia-sso-url-logs.html',
                        controller: 'RcopiaSsoUrlLogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }
})();
